// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2gOPb","list":"styles_list__vga2s"};